import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-data-transfer-actions',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `<button type="button" class="btn btn-secondary" (click)="exportRequested.emit()">
      <i class="la la-download" aria-hidden="true"></i>Export</button>
    <a *ngIf="importLink; else importAction" class="btn btn-secondary" [routerLink]="importLink">
      <i class="la la-upload" aria-hidden="true"></i>Import</a>
    <ng-template #importAction><button type="button" class="btn btn-secondary" (click)="importRequested.emit()">
      <i class="la la-upload" aria-hidden="true"></i>Import</button></ng-template>`,
  styles: [`:host { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }
    .btn { display: inline-flex; align-items: center; gap: 6px; min-height: 40px; }
    i { margin: 0; font-size: 18px; }`]
})
export class DataTransferActionsComponent {
  @Input() importLink: string;
  @Output() exportRequested = new EventEmitter<void>();
  @Output() importRequested = new EventEmitter<void>();
}
